import type { Messages } from '../index';

export const hlreImport: Messages['hlreImport'] = {
  header:
    'Import: {account} · Run: {runId} · Mode: {mode, select, DRY_RUN {Dry run} IMPORT {Import} FOLLOW_UP {Follow-up run} other {}} · Started by: {startedBy}',
  sections: {
    package: 'Package',
    setUp: 'Set-up',
    cases: 'Cases',
    decisionRows: 'Counts per decision row',
    drift: 'Drift',
    sideEffects: 'Side effects',
    notes: 'Notes',
  },
  package: {
    format: 'Format: {format}',
    runAt: 'Run date: {runAt}',
    preparedAt: 'Prepared at: {preparedAt}',
    checksums: 'Checksums',
  },
  cases: {
    counts: 'Created: {created} · Skipped: {skipped} · Failed: {failed}',
    failed: 'Failed',
    skipped: 'Skipped',
    created: 'Created',
    unknownKeys: 'Unknown keys',
  },
  decisionRows: {
    row: 'Row',
    package: 'Package',
    created: 'Created',
    skipped: 'Skipped',
    failed: 'Failed',
  },
  sideEffects: 'E-mails: {emails} · Language-model calls: {languageModelCalls} · Calendar entries: {calendarEntries}',
  setUpFailed: 'Set-up failed at {element}: {reason}. No case was imported.',
  phoneOmitted:
    'Company phone not taken over: "{raw}" is not a valid international number. Add it in the workspace if needed.',
  postalCodesSkipped: 'Standort postal codes: none in the package, assignment skipped.',
  setUp: {
    item: '{element}: {outcome, select, CREATED {created} EXISTING {existing} other {}}',
    elements: {
      COMPANY_ADDRESS: 'Company address',
      WORKSPACE: 'Workspace',
      COMPANY: 'Company',
      MAIN_ORGANIZATION: 'Main Standort',
      POSTAL_CODES: 'Postal codes',
      MEMBER: 'Member {subject}',
      LEAD_RECIPIENT: 'Lead recipient',
      LEAD_PARTNER: 'Lead partner HLRE',
      PARTNER_PROFILE: 'Partner profile',
      CONTACT_MAPPING: 'Contact mapping {subject}',
      HLRE_LINK: 'HLRE link',
    },
  },
  caseFailed: '{key}: not imported – {reason}. Import again with this key after the correction.',
  caseDrift: '{key}: already imported, changed in the package ({parts}). Nothing changed – please resolve manually.',
  caseReusedDrift:
    '{key}: {parts} reused from an earlier case, different in the package. Nothing changed – please resolve manually.',
  parts: {
    lead: 'Lead',
    statusHistory: 'Status',
    conversion: 'Conversion',
    deal: 'Deal',
    milestones: 'Milestones',
    conditions: 'Conditions',
    hlreState: 'HLRE state',
    activities: 'Activities',
    nextAction: 'Next action',
    propertyState: 'Property status',
    owner: 'Owner',
    property: 'Property',
  },
  passedPlannedAppointment: 'On-site appointment planned for {date} (not marked as held in Salesforce)',
  passedPlannedCall: 'Phone appointment planned for {date} (not marked as held in Salesforce)',
  none: 'None.',
  reportWritten: 'Report: {path}',
};
